import Controller, { inject as controller } from '@ember/controller';
import { inject as service } from '@ember/service';
import { computed, action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { SELLER_POSTINGS_APPLICATIONS_TAB_NAMES } from 'sh-www/constants/routes/postings';

const TAB_NAME_TO_ROUTE_MAP = {
  [SELLER_POSTINGS_APPLICATIONS_TAB_NAMES.HIRED]: EMBER_ROUTE_NAMES.POSTINGS__APPLICATIONS__HIRED,
  [SELLER_POSTINGS_APPLICATIONS_TAB_NAMES.SUBMITTED]: EMBER_ROUTE_NAMES.POSTINGS__APPLICATIONS__SUBMITTED,
};

/**
 * @param {string} name
 * @return {Ember.ComputedProperty}
 */
const pageTotal = (name) => readOnly(`${name}Controller.meta.pagination.total`);

class ApplicationsController extends Controller {
  @service router;

  @controller('postings.applications.submitted') submittedController;
  @controller('postings.applications.hired') hiredController;

  @pageTotal('submitted') submittedCount;
  @pageTotal('hired') hiredCount;

  activeNavItem = SELLER_POSTINGS_APPLICATIONS_TAB_NAMES.SUBMITTED;

  @computed('submittedCount', 'hiredCount')
  get countsObj() {
    return {
      [SELLER_POSTINGS_APPLICATIONS_TAB_NAMES.SUBMITTED]: this.submittedCount,
      [SELLER_POSTINGS_APPLICATIONS_TAB_NAMES.HIRED]: this.hiredCount,
    }
  }

  @computed('activeNavItem', 'countsObj')
  get navItems() {
    return Object.keys(SELLER_POSTINGS_APPLICATIONS_TAB_NAMES).map((tabKey) => {
      const tabName = SELLER_POSTINGS_APPLICATIONS_TAB_NAMES[tabKey];

      return {
        title: tabName,
        isActive: () => this.activeNavItem === tabName,
        count: this.countsObj[tabName],
      }
    });
  }

  @action
  onNavItemClicked(tab) {
    if (this.activeNavItem === tab) {
      return;
    }

    const selectedRoute = TAB_NAME_TO_ROUTE_MAP[tab];
    if (selectedRoute) {
      this.router.transitionTo(selectedRoute);
    } else {
      throw new Error('Invalid nav item clicked');
    }
  }
}

export default ApplicationsController;
